var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useContext, } from 'react';
import { TypographyFactory } from './TypographyFactory';
import { StyledListComponent, StyledListItemComponent } from './styles';
function defineFontFamily(size, fontFamily) {
    if (fontFamily === undefined && size > 2) {
        fontFamily = 'sansSerif';
    }
    else {
        fontFamily = 'serif';
    }
    return fontFamily;
}
export function Headline1(_a) {
    var { children, 'data-testid': testId = 'headline', asHTMLTag = 'h1', weight = 500, align, color = undefined } = _a, rest = __rest(_a, ["children", 'data-testid', "asHTMLTag", "weight", "align", "color"]);
    return (React.createElement(TypographyFactory, Object.assign({}, rest, { color: color, asHTMLTag: asHTMLTag, "data-testid": testId, size: 1, weight: weight, align: align, type: "headline", fontFamily: "serif" }), children));
}
export function Headline2(_a) {
    var { children, 'data-testid': testId = 'headline', asHTMLTag = 'h2', weight = 700, align, color = undefined } = _a, rest = __rest(_a, ["children", 'data-testid', "asHTMLTag", "weight", "align", "color"]);
    return (React.createElement(TypographyFactory, Object.assign({}, rest, { color: color, asHTMLTag: asHTMLTag, "data-testid": testId, size: 2, weight: weight, align: align, type: "headline", fontFamily: "serif" }), children));
}
export function Headline3(_a) {
    var { children, 'data-testid': testId = 'headline', asHTMLTag = 'h3', weight = 500, align, color = undefined } = _a, rest = __rest(_a, ["children", 'data-testid', "asHTMLTag", "weight", "align", "color"]);
    return (React.createElement(TypographyFactory, Object.assign({}, rest, { color: color, asHTMLTag: asHTMLTag, "data-testid": testId, size: 3, weight: weight, align: align, type: "headline", fontFamily: "serif" }), children));
}
export function Headline4(_a) {
    var { children, 'data-testid': testId = 'headline', asHTMLTag = 'h4', weight = 500, align, color = undefined } = _a, rest = __rest(_a, ["children", 'data-testid', "asHTMLTag", "weight", "align", "color"]);
    return (React.createElement(TypographyFactory, Object.assign({}, rest, { color: color, asHTMLTag: asHTMLTag, "data-testid": testId, size: 4, weight: weight, align: align, type: "headline", fontFamily: "serif" }), children));
}
export function Headline5(_a) {
    var { children, 'data-testid': testId = 'headline', asHTMLTag = 'h5', weight = 700, align, color = undefined } = _a, rest = __rest(_a, ["children", 'data-testid', "asHTMLTag", "weight", "align", "color"]);
    return (React.createElement(TypographyFactory, Object.assign({}, rest, { color: color, asHTMLTag: asHTMLTag, "data-testid": testId, size: 5, weight: weight, align: align, type: "headline", fontFamily: "serif" }), children));
}
export function Paragraph(_a) {
    var { children, 'data-testid': testId = 'paragraph', size = 1, fontFamily = undefined, weight = 300, asHTMLTag = 'p', align, whiteSpace = undefined, // Add default value for whiteSpace prop
    color = undefined } = _a, rest = __rest(_a, ["children", 'data-testid', "size", "fontFamily", "weight", "asHTMLTag", "align", "whiteSpace", "color"]);
    return (React.createElement(TypographyFactory, Object.assign({}, rest, { color: color, fontFamily: defineFontFamily(size, fontFamily), "data-testid": testId, asHTMLTag: asHTMLTag, size: size, weight: weight, align: align, whiteSpace: whiteSpace, type: "copy" }), children));
}
export const HeadlineChooser = (props) => {
    switch (props.variant) {
        case 'Headline1':
            return Headline1(props);
        case 'Headline2':
            return Headline2(props);
        case 'Headline3':
            return Headline3(props);
        case 'Headline4':
            return Headline4(props);
        case 'Headline5':
            return Headline5(props);
        default:
            return Headline1(props);
    }
};
export { Accent } from './styles';
const ListContext = createContext(undefined);
function useParentType() {
    return useContext(ListContext);
}
function createListProvider(parentType) {
    return function ListProvider({ children }) {
        return (React.createElement(ListContext.Provider, { value: parentType }, children));
    };
}
export function List(_a) {
    var { children = null, 'data-testid': testId, type = 'unordered', weight = 300, size = 1, fontFamily = undefined } = _a, rest = __rest(_a, ["children", 'data-testid', "type", "weight", "size", "fontFamily"]);
    const parentType = useParentType();
    const htmlTag = type === 'ordered' || parentType === 'ordered' ? 'ol' : 'ul';
    const element = (React.createElement(StyledListComponent, Object.assign({}, rest, { "$fontFamily": defineFontFamily(size, fontFamily), "data-testid": testId, as: htmlTag, "$type": type, "$size": size, "$weight": weight }), children));
    if (!parentType) {
        const ListProvider = createListProvider(type);
        return React.createElement(ListProvider, null, element);
    }
    return element;
}
export function ListItem(_a) {
    var { children = null } = _a, rest = __rest(_a, ["children"]);
    return React.createElement(StyledListItemComponent, Object.assign({}, rest), children);
}
